// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__CD7Ge","skeleton-loading":"skeleton_skeleton-loading__fqP07"};